module.exports = __webpack_public_path__ + "img/img_statement_template.d7df93db.png";